import React from 'react';

const Load: React.FC = () => {
    return (
        <div className="h-full w-full grid place-items-center">
            <div
                className="h-12 w-12 rounded-full border-4 border-white border-t-transparent animate-spin"
                aria-label="Loading"
            />
        </div>
    );
};

export default Load;
